export enum Unit {
  NUMBER = '#',
  PERCENT = '%',
  EURO = '€'
}
